import { LOCALES } from "./locales";

export function easter(year) {
    try {
        year = Number(year);
        if (year != year) {
            throw new TypeError("Value must be a number.");
        }
        else if (year > 275760 || year < -271820) {
            throw new RangeError("Value be between -271820 and 275760 due to technical limitations of Date constructor.");
        }
    }
    catch (e) { console && console.log(e); }

    year = Math.floor(year);
    var c = Math.floor(year / 100);
    var n = year - 19 * Math.floor(year / 19);
    var k = Math.floor((c - 17) / 25);
    var i = c - Math.floor(c / 4) - Math.floor((c - k) / 3) + 19 * n + 15;
    i = i - 30 * Math.floor(i / 30);
    i = i - Math.floor(i / 28) * (1 - Math.floor(i / 28) * Math.floor(29 / (i + 1)) * Math.floor((21 - n) / 11));
    var j = year + Math.floor(year / 4) + i + 2 - c + Math.floor(c / 4);
    j = j - 7 * Math.floor(j / 7);
    var l = i - j;
    var m = 3 + Math.floor((l + 40) / 44);
    var d = l + 28 - 31 * Math.floor(m / 4);
    var z = new DateG6k();
    z.setFullYear(year, m - 1, d);
    z.setHours(0, 0, 0, 0);
    return z;
}

export const HOLIDAYS = {
    "FR": {
        fixed_holidays: ["01-01", "05-01", "05-08", "07-14", "08-15", "11-01", "11-11", "12-25"],
        moveable_holidays: function (year, easterCallback = easter) {
            var holidays = [];
            var easter = easterCallback(year);
            holidays.push(easter.copy());
            holidays.push(easter.addDays(1).copy());
            holidays.push(easter.addDays(38).copy());
            holidays.push(easter.addDays(10).copy());
            holidays.push(easter.addDays(1).copy());
            return holidays;
        }
    },
    "US": {
        fixed_holidays: [],
        moveable_holidays: function (year) {
            return [];
        }
    },
};

export class DateG6k extends Date {
    static msPERDAY = 1000 * 60 * 60 * 24;
    static locales = LOCALES;
    static holidays = HOLIDAYS;
    static locale = "en-us";
    static format = "Y-m-d";
    static inputFormat = "Y-m-d";
    static regexp;
    static replacement;
    // msPERDAY = Date.msPERDAY;
    get msPERDAY() {
        return DateG6k.msPERDAY;
    }
    get locales() {
        return DateG6k.locales;
    }
    get holidays() {
        return DateG6k.holidays;
    }
    get locale() {
        return DateG6k.locale;
    }
    get format() {
        return DateG6k.format;
    }
    get inputFormat() {
        return DateG6k.inputFormat;
    }
    get regexp() {
        return DateG6k.regexp;
    }
    get replacement() {
        return DateG6k.replacement;
    }
    static makeRegExp() {
        var matches = DateG6k.inputFormat.match(/(j|n|Y)([^jnY]+)(j|n|Y)([^jnY]+)(j|n|Y)/);
        var regPart = [];
        var replacePart = [];
        for (var i = 1; i <= 5; i += 2) {
            if (matches[i] == 'j') {
                regPart.push('(\\d{1,2})');
                replacePart.push('$1');
            } else if (matches[i] == 'n') {
                regPart.push('(\\d{1,2})');
                replacePart.push('$2');
            } else {
                regPart.push('(\\d{4})');
                replacePart.push('$3');
            }
        }
        DateG6k.regexp = regPart[0] + matches[2] + regPart[1] + matches[4] + regPart[2];
        DateG6k.replacement = replacePart.join('.');
    }

    static setRegionalSettings(settings) {
        try{
            var locale = settings.locale.toLowerCase();
        }catch(error){
            console.log("Locale simulateur non défini, ajout par défaut locale 'fr-fr'");
            locale="fr-fr";
        }

        if (!DateG6k.locales[locale]) {
            locale = locale.substr(0, 2);
        }
        DateG6k.locale = locale;
        DateG6k.format = settings.dateFormat;
        DateG6k.inputFormat = settings.dateFormat.replace('d', 'j').replace('m', 'n');
        DateG6k.makeRegExp();
    }

    static nthDayOfMonth(nth, day, month, year) {
        var date = DateG6k.createFromFormat("Y-n-j", year + "-" + month + "-01");
        while (date.getDay() != day) {
            date.setDate(date.getDate() + 1);
        }
        date.setDate(date.getDate() + (nth - 1) * 7);
        return date;
    }

    holidaysOfYear(year, lang) {
        var country = "US";
        if (lang) {
            var c = lang.split("-");
            c = c[c.length - 1].toUpperCase();
            if (this.holidays[c]) {
                country = c;
            }
        }
        var fixed = this.holidays[country].fixed_holidays;
        var holidays = this.holidays[country].moveable_holidays(year);
        $.each(fixed, function(d, monthday) {
            holidays.push(DateG6k.createFromFormat("Y-n-j", year + "-" + monthday));
        });
        return holidays;
    }

    static createFromFormat(format, value) {

        if(DateG6k.isUtcDate(value)){
            return new DateG6k(value); //SIANCGI-POC
        }

        var now = new DateG6k();
        var parsed = {
            date: now.getDate(),
            year: now.getFullYear(),
            month: now.getMonth(),
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
        };
        try {
            for (var i = 0; i < format.length; i++) {
                var f = format.charAt(i);
                switch (f) {
                    case 'd':
                        parsed.date = parseInt(value.substring(0, 2), 10);
                        value = value.substring(2);
                        break;
                    case 'j':
                        var next = parseInt(value.charAt(1), 10);
                        var len = (next >= 0 && next <= 9) ? 2 : 1;
                        parsed.date = parseInt(value.substring(0, len), 10);
                        value = value.substring(len);
                        break;
                    case 'F':
                        var months = this.locales[this.getLocale()].month_names;
                        var len = months[0].length;
                        var month = value.substring(0, len);
                        value = value.substring(len);
                        for (var m = 0; m < 12; m++) {
                            if (months[m] == month) {
                                parsed.month = m;
                                break;
                            }
                        }
                        break;
                    case 'M':
                        var months = this.locales[this.getLocale()].month_names_short;
                        var len = months[0].length;
                        var month = value.substring(0, len);
                        value = value.substring(len);
                        for (var m = 0; m < 12; m++) {
                            if (months[m] == month) {
                                parsed.month = m;
                                break;
                            }
                        }
                        break;
                    case 'm':
                        parsed.month = parseInt(value.substring(0, 2), 10) - 1;
                        value = value.substring(2);
                        break;
                    case 'n':
                        var next = parseInt(value.charAt(1), 10);
                        var len = (next >= 0 && next <= 9) ? 2 : 1;
                        parsed.month = parseInt(value.substring(0, len), 10) - 1;
                        if (parsed.month > 11) {
                            throw new Error('Invalid month');
                        }
                        value = value.substring(len);
                        break;
                    case 'o':
                    case 'Y':
                        parsed.year = parseInt(value.substring(0, 4), 10);
                        value = value.substring(4);
                        break;
                    case 'y':
                        var year = parseInt(value.substring(0, 2), 10);
                        parsed.year = (year > 50) ? year + 1900 : year + 2000;
                        value = value.substring(2);
                        break;
                    case 'H':
                        parsed.hours = parseInt(value.substring(0, 2), 10);
                        value = value.substring(2);
                        break;
                    case 'G':
                        var next = parseInt(value.charAt(1), 10);
                        var len = (next >= 0 && next <= 9) ? 2 : 1;
                        parsed.hours = parseInt(value.substring(0, len), 10);
                        value = value.substring(len);
                        break;
                    case 'i':
                        parsed.minutes = parseInt(value.substring(0, 2), 10);
                        value = value.substring(2);
                        break;
                    case 's':
                        parsed.seconds = parseInt(value.substring(0, 2), 10);
                        value = value.substring(2);
                        break;
                    case 'u':
                        var len = 0;
                        for (var i = 0; i < value.length; i++) {
                            if (value.charAt(i) < '0' || value.charAt(i) > '9') {
                                break;
                            }
                            len++;
                        }
                        parsed.milliseconds = parseInt(value.substring(0, len), 10) / 1000;
                        value = value.substring(len);
                        break;
                    default:
                        value = value.substring(1);
                }
            }
            if (parsed.year > 9999) {
                throw 'Invalid year';
            }
            if (parsed.month > 11) {
                throw 'Invalid month';
            }
            if (!(parsed.year % 4) && (parsed.year % 100) || !(parsed.year % 400)) { // leap year
                if (parsed.date < 1 || (parsed.month == 1 && parsed.date > 29)) {
                    throw 'Invalid day';
                }
            } else {
                if (parsed.date < 1 || (parsed.month == 1 && parsed.date > 28)) {
                    throw 'Invalid day';
                }
            }
            if (parsed.hours > 23) {
                throw 'Invalid hours';
            }
            if (parsed.minutes > 59) {
                throw 'Invalid minutes';
            }
            if (parsed.seconds > 59) {
                throw 'Invalid seconds';
            }
            return new DateG6k(parsed.year, parsed.month, parsed.date, parsed.hours, parsed.minutes, parsed.seconds, parsed.milliseconds);
        } catch (err) {
            throw "Date parsing error : " + err;
        }
    }

    static isUtcDate(value){

        let utcDate = new RegExp("^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$");
        return utcDate.test(value);   
    }

    static isDate(value) {

        if(DateG6k.isUtcDate(value)){
            return true;
        }
        var re = new RegExp("^" + this.regexp + "$");
        return re.test(value);
    }

    copy() {
        return new DateG6k(+this);
    }

    workingDaysBefore(endDate) {
        
        // Validate input
        if (endDate < this)
            return 0;

        // Calculate days between dates
        var startDate = this.copy();
        startDate.setHours(0, 0, 0, 1); // Start just after midnight
        endDate.setHours(23, 59, 59, 999); // End just before midnight

        var diff = DateG6k.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()); // Milliseconds between datetime objects
        var days = Math.ceil(diff / this.msPERDAY) + 1;
        
        // Subtract two weekend days for every week in between
        var weeks = Math.floor(days / 7);
        var days = days - (weeks * 2);
        
        // Handle special cases
        var startDay = startDate.getDay();
        var endDay = endDate.getDay();

        // Remove weekend not previously removed.
        if (startDay - endDay > 1)
            days = days - 2;

        // Remove start day if span starts on Sunday but ends before Saturday
        if (startDay == 0 && endDay != 6)
            days = days - 1;

        // Remove end day if span ends on Saturday but starts after Sunday
        if (endDay == 6 && startDay != 0)
            days = days - 1;

        var locale = this.locale ? this.locale : "en-us";
        var startYear = startDate.getFullYear();
        var endYear = endDate.getFullYear();
        startDate.setHours(0, 0, 0, 0);       
        for (var y = startYear; y <= endYear; y++) {
            var holidays = this.holidaysOfYear(y, locale);
            $.each(holidays, function(h, holiday) {
                var d = holiday.getDay();
                if (d != 0 && d != 6 && holiday >= startDate && holiday <= endDate)
                    days = days - 1;
            });
        }
        return days;
    }

    isWorkingDay() {
        var day = this.getDay();
        if (day == 0 || day == 6) {
            return false;
        }
        var locale = this.locale ? this.locale : "en-us";
        var holidays = this.holidaysOfYear(this.getFullYear(), locale);
        var isHoliday = false;
        var self = this;
        $.each(holidays, function(h, holiday) {
            if (holiday == self) {
                isHoliday = true;
                return false;
            }
        });
        return !isHoliday;
    }

    nextWorkingDay() {
        var d = new DateG6k(+this);
        while (!d.isWorkingDay()) {
            d.addDays(1);
        }
        return d;
    }

    firstDayOfMonth() {
        return new DateG6k(this.getFullYear(), this.getMonth(), 1);
    }

    lastDayOfMonth() {
        return new DateG6k(this.getFullYear(), this.getMonth() + 1, 0);
    }

    lastday() {
        var d = new DateG6k(this.getFullYear(), this.getMonth() + 1, 0);
        return d.getDate();
    }

    getDaysBetween(d) {
        var tmp = d.copy();
        tmp.setHours(this.getHours(), this.getMinutes(), this.getSeconds(), this.getMilliseconds());
        var diff = tmp.getTime() - this.getTime();
        return Math.ceil(diff / this.msPERDAY);
    }

    getDayOfYear() {
        var start = new DateG6k(this.getFullYear(), 0, 0);
        return this.getDaysBetween(start) * -1;
    }

    getDaysInMonth() {
        var d = new DateG6k(this.getFullYear(), this.getMonth() + 1, 0);
        return d.getDate();
    }

    getWeekNumber() {
        var d = new DateG6k(+this);
        d.setHours(0, 0, 0);
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));
        return Math.ceil((((d - new DateG6k(d.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
    }

    isLeapYear(utc) {
        var y = utc ? this.getUTCFullYear() : this.getFullYear();
        return !(y % 4) && (y % 100) || !(y % 400) ? true : false;
    }

    addDays(d) {
        this.setTime(this.getTime() + d * this.msPERDAY);
        return this;
    }

    addWeeks(w) {
        this.addDays(w * 7);
        return this;
    }

    addMonths(m) {
        var d = this.getDate();
        this.setMonth(this.getMonth() + m);
        if (this.getDate() < d)
            this.setDate(0);
        return this;
    }

    addYears(y) {
        var m = this.getMonth();
        this.setFullYear(this.getFullYear() + y);
        if (m < this.getMonth()) {
            this.setDate(0);
        }
        return this;
    }

    addWeekDays(d) {
        var startDay = this.getDay(); //current weekday 0 thru 6
        var wkEnds = 0; //# of weekends needed
        var partialWeek = d % 5; //# of weekdays for partial week
        if (d < 0) { //subtracting weekdays
            wkEnds = Math.ceil(d / 5); //negative number weekends
            switch (startDay) {
                case 6: //start Sat. 1 less weekend
                    if (partialWeek == 0 && wkEnds < 0)
                        wkEnds++;
                    break;
                case 0: //starting day is Sunday
                    if (partialWeek == 0)
                        d++; //decrease days to add
                    else
                        d--; //increase days to add
                    break;
                default:
                    if (partialWeek <= -startDay)
                        wkEnds--;
            }
        } else if (d > 0) { //adding weekdays
            wkEnds = Math.floor(d / 5);
            var w = wkEnds;
            switch (startDay) {
                case 6:
                    /* If staring day is Sat. and
                     * no partial week one less day needed
                     * if partial week one more day needed
                     */
                    if (partialWeek == 0)
                        d--;
                    else
                        d++;
                    break;
                case 0: //Sunday
                    if (partialWeek == 0 && wkEnds > 0)
                        wkEnds--;
                    break;
                default:
                    if (5 - day < partialWeek)
                        wkEnds++;
            }
        }
        d += wkEnds * 2;
        this.addDays(d);
        return this;
    }

    getWeekDays(d) {
        var wkEnds = 0;
        var days = Math.abs(this.getDaysBetween(d));
        var startDay = 0,
            endDay = 0;
        if (days) {
            if (d < this) {
                startDay = d.getDay();
                endDay = this.getDay();
            } else {
                startDay = this.getDay();
                endDay = d.getDay();
            }
            wkEnds = Math.floor(days / 7);
            if (startDay != 6 && startDay > endDay)
                wkEnds++;
            if (startDay != endDay && (startDay == 6 || endDay == 6))
                days--;
            days -= (wkEnds * 2);
        }
        return days;
    }

    getMonthsBetween(d) {
        var sDate, eDate;
        var d1 = this.getFullYear() * 12 + this.getMonth();
        var d2 = d.getFullYear() * 12 + d.getMonth();
        var sign;
        var months = 0;
        if (this == d) {
            months = 0;
        } else if (d1 == d2) { //same year and month
            months = (d.getDate() - this.getDate()) / this.lastday();
        } else {
            if (d1 < d2) {
                sDate = this;
                eDate = d;
                sign = 1;
            } else {
                sDate = d;
                eDate = this;
                sign = -1;
            }
            var sAdj = sDate.lastday() - sDate.getDate();
            var eAdj = eDate.getDate();
            var adj = (sAdj + eAdj) / sDate.lastday() - 1;
            months = Math.abs(d2 - d1) + adj;
            months = (months * sign);
        }
        return months;
    }

    getYearsBetween(d) {
        var months = this.getMonthsBetween(d);
        return months / 12;
    }

    getAge() {
        var today = new DateG6k();
        return this.getYearsBetween(today).toFixed(2);
    }

    sameDayEachWeek(day, date) {
        var aDays = new Array();
        var eDate, nextDate, adj;
        if (this > date) {
            eDate = this;
            nextDate = date.copy();
        } else {
            eDate = date;
            nextDate = this.copy();
        }
        adj = (day - nextDate.getDay() + 7) % 7;
        nextDate.setDate(nextDate.getDate() + adj);
        while (nextDate < eDate) {
            aDays[aDays.length] = nextDate.copy();
            nextDate.setDate(nextDate.getDate() + 7);
        }
        return aDays;
    }

    static toDate(d) {
        var newDate;
        if (arguments.length == 0) {
            newDate = new DateG6k();
        } else if (d instanceof DateG6k) {
            newDate = new DateG6k(d.getTime());
        } else if (typeof d == "string") {
            newDate = new DateG6k(d);
        } else if (arguments.length >= 3) {
            var dte = [0, 0, 0, 0, 0, 0];
            for (var i = 0; i < arguments.length && i < 7; i++) {
                dte[i] = arguments[i];
            }
            newDate = new DateG6k(dte[0], dte[1], dte[2], dte[3], dte[4], dte[5]);
        } else if (typeof d == "number") {
            newDate = new DateG6k(d);
        } else {
            newDate = null;
        }
        if (newDate == "Invalid Date")
            return null;
        else
            return newDate;
    }

    setLocale(lang) {
        if (lang && lang in this.locales) {
            this.locale = lang;
        }
        return this;
    }

    getLocale() {
        return this.locale || "en";
    }

    getMonthName(lang) {
        var locale = "en";
        if (lang && lang in this.locales) {
            locale = lang;
        } else if (this.locale && this.locale in this.locales) {
            locale = this.locale;
        }
        return this.locales[locale].month_names[this.getMonth()];
    }

    getMonthNameShort(lang) {
        var locale = "en";
        if (lang && lang in this.locales) {
            locale = lang;
        } else if (this.locale && this.locale in this.locales) {
            locale = this.locale;
        }
        return this.locales[locale].month_names_short[this.getMonth()];
    }

    getDayName(lang) {
        var locale = "en";
        if (lang && lang in this.locales) {
            locale = lang;
        } else if (this.locale && this.locale in this.locales) {
            locale = this.locale;
        }
        return this.locales[locale].day_names[this.getDay()];
    }

    getDayNameShort(lang) {
        var locale = "en";
        if (lang && lang in this.locales) {
            locale = lang;
        } else if (this.locale && this.locale in this.locales) {
            locale = this.locale;
        }
        return this.locales[locale].day_names_short[this.getDay()];
    }

    getDateSuffix(lang) {
        var locale = "en";
        if (lang && lang in this.locales) {
            locale = lang;
        } else if (this.locale && this.locale in this.locales) {
            locale = this.locale;
        }
        return this.locales[locale].date_suffix(this.getDate());
    }

    getMeridiem(isLower, lang) {
        var locale = "en";
        if (lang && lang in this.locales) {
            locale = lang;
        } else if (this.locale && this.locale in this.locales) {
            locale = this.locale;
        }
        return this.locales[locale].meridiem(this.getHours(), this.getMinutes(), isLower);
    }

    getLastDate() {
        return (new DateG6k(this.getFullYear(), this.getMonth() + 1, 0)).getDate();
    }

    format(formatString) {

        var addPadding = function(value, length) {
            var negative = ((value < 0) ? "-" : "");
            var zeros = "0";
            for (var i = 2; i < length; i++) {
                zeros += "0";
            }
            return negative + (zeros + Math.abs(value).toString()).slice(-length);
        };

        var replacements = {
            date: this,
            d: function() {
                return addPadding(this.date.getDate(), 2);
            },
            D: function() {
                return this.date.getDayNameShort();
            },
            j: function() {
                return this.date.getDate();
            },
            l: function() {
                return this.date.getDayName();
            },
            N: function() {
                return this.date.getDay() + 1;
            },
            S: function() {
                return this.date.getDateSuffix();
            },
            w: function() {
                return this.date.getDay();
            },
            z: function() {
                return this.date.getDayOfYear();
            },
            W: function() {
                return this.date.getWeekNumber();
            },
            F: function() {
                return this.date.getMonthName();
            },
            m: function() {
                return addPadding((this.date.getMonth() + 1), 2);
            },
            M: function() {
                return this.date.getMonthNameShort();
            },
            n: function() {
                return this.date.getMonth() + 1;
            },
            t: function() {
                return this.date.getDaysInMonth();
            },
            L: function() {
                return this.date.isLeapYear() ? 1 : 0;
            },
            o: function() {
                return this.date.getFullYear();
            },
            Y: function() {
                return this.date.getFullYear();
            },
            y: function() {
                return this.date.getFullYear() % 100;
            },
            a: function() {
                return this.date.getMeridiem(true);
            },
            A: function() {
                return this.date.getMeridiem(false);
            },
            H: function() {
                return addPadding(this.date.getHours(), 2);
            },
            G: function() {
                return this.date.getHours();
            },
            h: function() {
                var hour = this.date.getHours();
                if (hour > 12) {
                    hour -= 12;
                } else if (hour < 1) {
                    hour = 12;
                }
                return addPadding(hour, 2);
            },
            g: function() {
                var hour = this.date.getHours();
                if (hour > 12) {
                    hour -= 12;
                } else if (hour < 1) {
                    hour = 12;
                }
                return hour;
            },
            i: function() {
                return addPadding(this.date.getMinutes(), 2);
            },
            s: function() {
                return addPadding(this.date.getSeconds(), 2);
            },
            u: function() {
                return Math.floor(this.date.getMilliseconds() * 1000);
            },
            Z: function() {
                return this.date.getTimezoneOffset() * 60;
            },
            P: function() {
                return Math.floor(-this.date.getTimezoneOffset() / 60) + ":" + addPadding(-this.date.getTimezoneOffset() % 60, 2);
            }
        };

        var formats = new Array();
        while (formatString.length > 0) {
            if (formatString[0] === "\"") {
                var temp = /"[^"]*"/m.exec(formatString);
                if (temp === null) {
                    formats.push(formatString.substring(1));
                    formatString = "";
                } else {
                    temp = temp[0].substring(1, temp[0].length - 1);
                    formats.push(temp);
                    formatString = formatString.substring(temp.length + 2);
                }
            } else if (formatString[0] === "'") {
                var temp = /'[^']*'/m.exec(formatString);
                if (temp === null) {
                    formats.push(formatString.substring(1));
                    formatString = "";
                } else {
                    temp = temp[0].substring(1, temp[0].length - 1);
                    formats.push(temp);
                    formatString = formatString.substring(temp.length + 2);
                }
            } else if (formatString[0] === "\\") {
                if (formatString.length > 1) {
                    formats.push(formatString.substring(1, 2));
                    formatString = formatString.substring(2);
                } else {
                    formats.push("\\");
                    formatString = "";
                }
            } else {
                var foundMatch = false;
                for (var i = formatString.length; i > 0; i--) {
                    if (formatString.substring(0, i) in replacements) {
                        formats.push(replacements[formatString.substring(0, i)]());
                        formatString = formatString.substring(i);
                        foundMatch = true;
                        break;
                    }
                }
                if (!foundMatch) {
                    formats.push(formatString[0]);
                    formatString = formatString.substring(1);
                }
            }
        }

        return formats.join("");
    }
}
